import { Button, FormControl, FormErrorMessage, FormLabel, HStack, Input, useToast, VStack } from "@chakra-ui/react"
import { useFormik } from "formik"
import React from "react"
import DateTimePicker from "react-datetime-picker"
import "react-calendar/dist/Calendar.css"
import "react-clock/dist/Clock.css"
import "react-datetime-picker/dist/DateTimePicker.css"
import * as Yup from "yup"
import { useMarkUserAttendanceInMutation } from "../graphql"
import { isValid } from "date-fns"

type MarkManualUserAttendanceInFormValues = {
	inTime: Date
	inRemarks: string
}

const validationSchema = Yup.object({
	inTime: Yup.date().required().label("In Time"),
	inRemarks: Yup.string().required().label("In Remarks"),
})

export type MarkManualUserAttendanceInFormProps = {
	userId: string
}
const MarkManualUserAttendanceInForm: React.FC<MarkManualUserAttendanceInFormProps> = ({ userId }) => {
	const [{ fetching }, markUserAttendanceInMutation] = useMarkUserAttendanceInMutation()
	const [isOptionSelected, setIsOptionSelected] = React.useState(false)
	const [isOtherSelected, setIsOtherSelected] = React.useState(false)

	const handleSubmit = async (values: MarkManualUserAttendanceInFormValues) => {
		const { data, error } = await markUserAttendanceInMutation({
			userId: userId,
			inTime: new Date(values.inTime),
			inRemarks: values.inRemarks,
		})

		if (error) {
			toast({
				title: "Error",
				description: error.message.replace("[GraphQL] ", ""),
				status: "error",
				duration: 5000,
				isClosable: true,
			})
			return
		}

		if (data?.markUserAttendanceIn) {
			toast({
				title: "Attendance marked In",
				description: "Attendance marked successfully",
				status: "success",
				duration: 5000,
				isClosable: true,
			})
		}
	}
	const formik = useFormik<MarkManualUserAttendanceInFormValues>({
		initialValues: {
			inTime: new Date(),
			inRemarks: "",
		},
		validationSchema: validationSchema,
		onSubmit: handleSubmit,
	})

	const toast = useToast()
	const options = ["No electricity", "Internet issue", "Card Punch issue", "Machine Not wroking"]

	return (
		<VStack w="fit-content" align="flex-start" pl="4">
			<form onSubmit={formik.handleSubmit}>
				<VStack w="full" maxW="lg" align="stretch" spacing={4}>
					<FormControl id="inTime">
						<FormLabel>In Date</FormLabel>
						<DateTimePicker onChange={(value) => isValid(value) && formik.setFieldValue("inTime", value)} value={formik.values.inTime} format="dd/MM/yyyy hh:mm a" maxDate={new Date()} clearIcon={null} />
					</FormControl>

					<FormControl id="inRemarks" isInvalid={!!formik.errors.inRemarks && formik.touched.inRemarks}>
						<FormLabel>In Remarks</FormLabel>
						<HStack justifyContent={"flex-start"} gap={5} wrap="wrap">
							{options.map((option, index) => (
								<Button
									variant={isOptionSelected ? (formik.values.inRemarks === option ? "solid" : "outline") : "outline"}
									colorScheme="primary"
									color={isOptionSelected ? (formik.values.inRemarks === option ? "white" : "primary.500") : "primary.500"}
									size="sm"
									p={2}
									key={index}
									onClick={() => {
										formik.setFieldValue("inRemarks", option)
										setIsOptionSelected(true)
									}}
								>
									{option}
								</Button>
							))}
							<Button
								variant={isOtherSelected ? "solid" : "outline"}
								colorScheme="primary"
								color={isOtherSelected ? "white" : "primary.500"}
								size="sm"
								p={2}
								onClick={() => {
									formik.setFieldValue("inRemarks", "")
									setIsOtherSelected(!isOtherSelected)

									formik.setFieldValue("inRemarks", "")
								}}
							>
								Other
							</Button>
						</HStack>
						<FormErrorMessage>{formik.errors.inRemarks}</FormErrorMessage>
					</FormControl>

					{isOtherSelected && (
						<FormControl id="inRemarks" isInvalid={!!formik.errors.inRemarks && formik.touched.inRemarks}>
							<FormLabel>In Remarks</FormLabel>
							<Input {...formik.getFieldProps("inRemarks")} />
							<FormErrorMessage>{formik.errors.inRemarks}</FormErrorMessage>
						</FormControl>
					)}
					<Button size="sm" alignSelf="flex-start" type="submit" isLoading={fetching} colorScheme="primary">
						Mark In
					</Button>
				</VStack>
			</form>
		</VStack>
	)
}

export default MarkManualUserAttendanceInForm
